import React, { useState, useEffect } from "react";
import { FaCubes, FaTimes } from "react-icons/fa";
import { removeFromQueue } from "../store/guestsStore";
import "./SeatedGuestCard.css";
import { removeFromSeated } from "../store/guestsStore"; // Import the correct event
import FeedbackPopup from "./FeedbackPopup"; // Import the new popup
import { updateGuest } from "../store/guestsStore"; // Import event to update store

const SeatedGuestCard = ({ guest }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [initialTime, setInitialTime] = useState(null); // 🔹 Set to `null` initially

  useEffect(() => {
    const seatedGuests = JSON.parse(localStorage.getItem("seatedGuests")) || [];
    const guestData = seatedGuests.find((g) => g.id === guest.id);

    if (guestData && guestData.seatedAt) {
      const now = Date.now();
      const timePassed = Math.floor((now - guestData.seatedAt) / 1000); // Convert to seconds

      fetch(
        "https://uvjwfdf5aa.execute-api.eu-west-1.amazonaws.com/test/setup-configuration-api",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ place_id: "shka17c8h3", action: "read" }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          const timerMinutes =
            data?.data?.hookah_config?.coal_refresh_timer_minutes || 5;
          const totalTime = timerMinutes * 60;
          setInitialTime(totalTime);
          setTimeLeft(totalTime - timePassed);
        })
        .catch((error) => console.error("❌ Error fetching timer:", error));
    }
  }, []);

  useEffect(() => {
    if (initialTime === null) return;
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        const newTime = prev - 1;

        // 🔹 Update guest's time in Effector store to trigger reactivity
        updateGuest({ id: guest.id, seatedAt: guest.seatedAt });

        return newTime;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [initialTime]);

  const resetTimer = () => {
    if (initialTime !== null) {
      setTimeLeft(initialTime);

      // Update seated time in localStorage
      const seatedGuests =
        JSON.parse(localStorage.getItem("seatedGuests")) || [];
      const updatedSeatedGuests = seatedGuests.map((g) =>
        g.id === guest.id ? { ...g, seatedAt: Date.now() } : g
      );

      localStorage.setItem("seatedGuests", JSON.stringify(updatedSeatedGuests));

      // 🔥 Trigger UI re-render to update the order
      if (window.triggerSeatedGuestsRerender) {
        window.triggerSeatedGuestsRerender();
      }
    }
  };

  const getTimerClass = () => {
    if (initialTime === null) return "timer normal";
    if (timeLeft <= 0) return "timer expired"; // Stays red after expiration
    if (timeLeft <= initialTime / 2) return "timer warning"; // Orange transition
    return "timer normal";
  };

  const closeTable = () => {
    removeFromSeated(guest.id); // Remove guest from seatedGuests
    setShowPopup(false); // Close popup
  };

  return (
    <div className="seated-guest-card">
      <div className="seated-header">
        {/* Photo */}
        <div className="guest-photo-container">
          <img src={guest.photo} alt={guest.name} className="guest-photo" />
          {/* Move "Оценить" to bottom-center */}
          <div
            className="guest-rating-tag"
            onClick={() => setShowFeedbackPopup(true)}
          >
            ⭐ Оценить
          </div>
        </div>

        {/* Table Number (Same size as photo) */}
        <div className="table-number-tag">
          <p>№ стола:</p>
          <strong>{guest.tableNumber || "?"}</strong>
        </div>

        {/* "X" Button */}
        <button className="close-x-btn" onClick={() => setShowPopup(true)}>
          <FaTimes size={24} />
        </button>
      </div>

      {/* Timer */}
      {/* Timer with dynamic color */}
      <div className={getTimerClass()}>
        ⏳ {timeLeft < 0 ? "-" : ""}
        {Math.floor(Math.abs(timeLeft) / 60)}:
        {String(Math.abs(timeLeft) % 60).padStart(2, "0")}
        <p>
          {timeLeft <= 0 ? "Замените угли / закройте стол" : "До замены углей"}
        </p>
      </div>

      {/* Buttons with Icons */}
      <div className="seated-guest-actions">
        <button className="change-coal-btn" onClick={resetTimer}>
          <FaCubes size={24} /> {/* 🔹 Replace text with icon */}
        </button>
        <button className="close-table-btn" onClick={() => setShowPopup(true)}>
          <img src="/hookah.png" alt="Hookah" width="24" height="24" />
        </button>
      </div>

      {/* Confirmation Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <p className="popup-message">Закрыть стол?</p>
            <div className="popup-buttons">
              <button className="popup-yes" onClick={closeTable}>
                Да
              </button>
              <button className="popup-no" onClick={() => setShowPopup(false)}>
                Нет
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Feedback Popup */}
      {showFeedbackPopup && (
        <FeedbackPopup
          guest={guest}
          onClose={() => setShowFeedbackPopup(false)}
        />
      )}
    </div>
  );
};

export default SeatedGuestCard;
